import { css } from 'styled-components';

export const wellobeTheme = css`
    --color-primary: #8012EA;
    
    --color-state-primary: rgba(128, 18, 234, 0.07);
    --color-state-secondary: rgba(128, 18, 234, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: rgb(189, 165, 255);

    /* Home Page */
    --home-hero-background: linear-gradient(87deg, #8012EA 27.52%, #9328FB 63.82%);
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: #E0D7FF;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: var(--color-primary);
`;
